import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import TermsAndConditions from './views/TermsAndConditions.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
// import Student from './modules/student/router'
import Teacher from './modules/teacher/router'
import Client from './modules/client/router/custom.js'
// import Individual from './modules/individual/router'
import Parent from './modules/parent/router'
import User from './modules/user/router'
import PageNotFound from './modules/error/views/PageNotFound.vue'
import moment from 'moment'
import { TokenService } from './services/storage.service'
import authLogout from '@/modules/auth/mixins/authLogout'

// get logout function from mixin
const logout = authLogout.methods.logoutReturnUrl
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        public: true
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacy',
      component: PrivacyPolicy,
      meta: {
        public: true
      }
    },
    {
      path: '/terms-and-conditions',
      name: 'terms',
      component: TermsAndConditions,
      meta: {
        public: true
      }
    },
    // ...Student,
    ...Teacher,
    ...Client,
    // ...Individual,
    ...Parent,
    ...User,
    {
      path: '*',
      component: PageNotFound,
      meta: {
        public: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.meta.public && !to.meta.type) {
    console.error('Every route needs to have a meta type')
    return
  }

  const isPrivate = to.matched.some(record => record.meta.private)
  const lastActivity = parseInt(
    TokenService.getToken(`${to.meta.type}-last-activity`)
  )

  const halfAnHourAgo = moment()
    .utc()
    .subtract(45, 'minutes')
    .unix()

  if (isPrivate && !lastActivity && lastActivity < halfAnHourAgo) {
    next(logout(to.meta.type))
  }
  next()
})

export default router
